export const LOCALES = {
    ENGLISH : 'en-US',
    FRENCH : 'fr-CA'
} 

